import { env } from './env'
import { isNativeApp } from '../utils/platform'

const NATIVE_OAUTH_CALLBACK = 'ascendcomms://auth/callback'
const NATIVE_OAUTH_SIGN_OUT = 'ascendcomms://logout'

/** Hosted UI domain without protocol, e.g. dev-auth.ascendhealthplus.com */
export function getCognitoHostedDomain(): string {
  return env.cognitoDomain.replace(/^https?:\/\//, '').replace(/\/$/, '')
}

export function getOAuthRedirectSignIn(): string {
  if (isNativeApp()) {
    return NATIVE_OAUTH_CALLBACK
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/auth/callback`
  }
  return 'http://localhost:5173/auth/callback'
}

export function getOAuthRedirectSignOut(): string {
  if (isNativeApp()) {
    return NATIVE_OAUTH_SIGN_OUT
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/`
  }
  return 'http://localhost:5173/'
}

export function isCognitoConfigured(): boolean {
  return Boolean(env.cognitoUserPoolId && env.cognitoClientId && env.cognitoDomain)
}
